(() => {
  if (window.mxproCustomerHelpStarted) return;
  const settingsElement = document.getElementById('mxpro-customer-help-settings');
  if (!settingsElement) return;
  let settings;
  try {
    settings = JSON.parse(settingsElement.textContent);
  } catch (_) {
    return;
  }
  window.mxproCustomerHelpStarted = true;

  const ownSelector = '[data-mxpro-customer-help-own]';
  const inputSelector = 'input.search__input[name="q"], input.boost-sd__search-widget-init-input, input.boost-sd__search-form-input';
  let generatedInputId = 0;
  let pendingFrame = 0;

  let vehicleRules = null;
  function motorName(pathname) {
    const tag = pathname.match(/\/collections\/(?:[^/]+\/)?((?:mxpro-ymm-[a-f0-9]+|mxp-fit-[a-z0-9-]+|[a-z0-9-]+-esi\d+))(?:\/|$)/)?.[1];
    if (tag) {
      const rule = vehicleRules?.[tag];
      if (!rule) return '';
      let selected = null;
      try { selected = JSON.parse(sessionStorage.getItem('mxpro-ymm-selection-v1')); } catch (_) { /* Use the verified year range when no selection is stored. */ }
      const valid = selected?.path === pathname && selected.make === rule.make && String(selected.model).replace(/‚/g, ',') === rule.model && Number(selected.year) >= rule.start && Number(selected.year) <= rule.end;
      const year = valid ? selected.year : rule.start === rule.end ? rule.start : `${rule.start}–${rule.end}`;
      return `${rule.make} ${rule.model} (${year})`;
    }
    return '';
  }

  function updateMotor() {
    const banner = document.getElementById('mxpro-selected-motor');
    if (!banner) return;
    const name = motorName(window.location.pathname);
    const nameElement = banner.querySelector('[data-mxpro-selected-motor-name]');
    if (nameElement && nameElement.textContent !== name) nameElement.textContent = name;
    banner.hidden = !name;
  }

  function updateSearchLabels() {
    document.querySelectorAll('.mxpro-search-scope[data-mxpro-search-for]').forEach(group => {
      if (!document.getElementById(group.dataset.mxproSearchFor)) group.remove();
    });
    document.querySelectorAll(inputSelector).forEach(input => {
      if (!input.id) input.id = `mxpro-search-input-${++generatedInputId}`;
      const host = input.closest('.field') || input.parentElement;
      if (!host || !host.parentElement) return;
      const existing = Array.from(host.parentElement.children).find(element =>
        element.dataset && element.dataset.mxproSearchFor === input.id
      );
      const noteId = `${input.id}-mxpro-scope`;
      if (!existing) {
        const group = document.createElement('div');
        group.className = 'mxpro-search-scope';
        group.dataset.mxproCustomerHelpOwn = '';
        group.dataset.mxproSearchFor = input.id;
        const label = document.createElement('label');
        label.htmlFor = input.id;
        label.className = 'mxpro-search-scope__label';
        label.textContent = settings.searchLabel;
        const hint = document.createElement('small');
        hint.id = noteId;
        hint.className = 'mxpro-search-scope__hint';
        hint.textContent = settings.searchHint;
        group.append(label, hint);
        host.before(group);
      }
      input.setAttribute('aria-label', settings.searchLabel);
      const describedBy = (input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
      if (!describedBy.includes(noteId)) {
        input.setAttribute('aria-describedby', [...describedBy, noteId].join(' '));
      }
    });
  }

  function updateRecovery() {
    const removeRecovery = () => document.querySelectorAll('.mxpro-search-recovery').forEach(element => element.remove());
    if (!/\/search\/?$/.test(window.location.pathname)) {
      removeRecovery();
      return;
    }
    const template = document.getElementById('mxpro-search-recovery-template');
    if (!template) return;
    const boostEmpty = document.querySelector('.boost-sd__no-search-result-page');
    const boostCount = document.getElementById('results-number');
    if (boostCount && Number(boostCount.dataset.totalProduct) > 0) {
      removeRecovery();
      return;
    }
    let target = boostEmpty;
    if (!target && !boostCount) {
      target = document.querySelector('.template-search--empty .collection--empty, .template-search--empty .template-search__results');
    }
    if (!target) {
      removeRecovery();
      return;
    }
    let recovery = target.querySelector('.mxpro-search-recovery');
    if (!recovery) {
      recovery = template.content.firstElementChild.cloneNode(true);
      target.append(recovery);
    }
    const query = new URL(window.location.href).searchParams.get('q') || '';
    const title = recovery.querySelector('[data-mxpro-empty-title]');
    const text = settings.emptyTitle.replace('__MXPRO_QUERY__', query);
    if (title && title.textContent !== text) title.textContent = text;
  }

  function update() {
    pendingFrame = 0;
    updateMotor();
    updateSearchLabels();
    updateRecovery();
  }

  function scheduleUpdate() {
    if (!pendingFrame) pendingFrame = window.requestAnimationFrame(update);
  }

  const observer = new MutationObserver(records => {
    const externalChange = records.some(record => {
      if (record.target instanceof Element && record.target.closest(ownSelector)) return false;
      return [...record.addedNodes, ...record.removedNodes].some(node =>
        node instanceof Element && !node.matches(ownSelector)
      );
    });
    if (externalChange) scheduleUpdate();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('popstate', scheduleUpdate);
  window.addEventListener('pageshow', scheduleUpdate);
  if (/\/collections\/(?:[^/]+\/)?(?:mxpro-ymm-[a-f0-9]+|mxp-fit-[a-z0-9-]+|[a-z0-9-]+-esi\d+)(?:\/|$)/.test(window.location.pathname)) {
    const config = document.getElementById('mxpro-fitment-labels');
    let url;
    try { url = config && JSON.parse(config.textContent).rulesUrl; } catch (_) { /* Existing search support remains available. */ }
    if (url) fetch(url).then(response => { if (!response.ok) throw new Error('Vehicle list unavailable'); return response.json(); }).then(rules => { vehicleRules = rules; scheduleUpdate(); }).catch(() => {});
  }
  update();
})();

